import { store } from 'src/redux/store';

export const isThreadServiceEnabled = () => {
  const { profile } = store.getState();
  const { loggedIn } = profile || {};

  return loggedIn;
};
